/**
 * 从 delivery 域内「异步报表生成完成」弹窗跳转到 /delivery/download 时携带的 history state，
 * 用于默认筛选「看板导出」；其它入口进入下载页时不应设置此字段。
 */
export const DELIVERY_DOWNLOAD_FROM_ASYNC_DASHBOARD_STATE_KEY = 'deliveryDownloadFromAsyncDashboardExport';

/**
 * 从「罚单管理中心」下载弹窗跳转到下载页时携带的 history state，
 * 用于默认筛选「罚单管理中心导出」。
 * 目标页按入口决定：DSP 侧落 /delivery/download，仓库侧落 /wms/download（常量名沿用历史命名）。
 */
export const DELIVERY_DOWNLOAD_FROM_PARTNER_PENALTY_STATE_KEY = 'deliveryDownloadFromPartnerPenaltyExport';
